// extracted by mini-css-extract-plugin
export default {"exitIcon":"ExitIcon-module__exitIcon_qURye"};